import z from 'zod'

export const signupFormSchema = z.object({
  name: z
    .string({ required_error: '名前を入力してください' })
    .min(1, { message: '名前を入力してください' }),
  email: z
    .string({ required_error: 'メールアドレスを入力してください' })
    .email('メールアドレスを入力してください'),
  password: z
    .string({ required_error: 'パスワードを入力してください' })
    .min(8, { message: 'パスワードは8文字以上で入力してください' }),
  termAndPrivacy: z
    .string({
      required_error: '利用規約とプライバシーポリシーに同意してください',
    })
    .refine(
      (value) => {
        return value === 'on'
      },
      { message: '利用規約とプライバシーポリシーに同意してください' },
    ),
})

export type SignupFormSchema = z.infer<typeof signupFormSchema>
